export const codeToName: Record<string, string> = {
  o001: "[응급실] 일반",
  o002: "[응급실] 소아",
  o003: "[응급실] 음압격리",
  o004: "[응급실] 일반격리",
  o005: "[입원][응급전용] 중환자실",
  o006: "[입원][중환자실] 내과",
  o007: "[입원][중환자실] 외과",
  o008: "[입원][중환자실] 신생아",
  o009: "[입원][중환자실] 소아",
  o010: "[입원][응급전용] 소아 중환자실",
  o011: "[입원][중환자실] 신경과",
  o012: "[입원][중환자실] 신경외과",
  o013: "[입원][중환자실] 화상",
  o014: "[입원] [외상전용] 중환자실",
  o015: "[입원][중환자실] 심장내과",
  o016: "[입원][중환자실] 흉부외과",
  o017: "[입원][중환자실] 일반",
  o018: "[입원][중환자실] 음압격리",
  o019: "[입원][응급전용] 입원실",
  o020: "[입원][응급전용] 소아 입원실",
  o021: "[입원] [외상전용] 입원실",
  o022: "[입원] [기타] 수술실",
  o023: "[입원] [외상전용] 수술실",
  o024: "[입원] [입원실] 정신과 폐쇄병동",
  o025: "[입원] [입원실] 음압격리",
  o026: "[입원] [기타] 분만실",
  o027: "CT가용(가/부)",
  o028: "MRI가용(가/부)",
  o029: "혈관촬영기가용(가/부)",
  o030: "인공호흡기 일반가용",
  o031: "인공호흡기 조산아가용",
  o032: "인큐베이터가용",
  o033: "CRRT가용",
  o034: "ECMO가용",
  o035: "중심체온조절유도기 가용",
  o037: "고압산소치료기 가용",
  o036: "[입원] [기타] 화상전용처치실",
  o038: "[입원] [입원실] 일반",
  o048: "[응급실] 소아음압격리",
  o049: "[응급실] 소아일반격리",
  o050: "[입원][응급전용] 중환자실 음압격리",
  o051: "[입원][응급전용] 중환자실 일반격리",
  o052: "[입원][응급전용] 입원실 음압격리",
  o053: "[입원][응급전용] 입원실 일반격리",
  o059: "[응급실] 코호트격리",
  o060: "[응급실] 외상소생실",
  y0010: "[재관류중재술] 심근경색",
  y0020: "[재관류중재술] 뇌경색",
  y0031: "[뇌출혈수술] 거미막하출혈",
  y0032: "[뇌출혈수술] 거미막하출혈 외",
  y0041: "[대동맥응급] 흉부",
  y0042: "[대동맥응급] 복부",
  y0051: "[담낭담관질환] 담낭질환",
  y0052: "[담낭담관질환] 담도포함질환",
  y0060: "[복부응급수술] 비외상",
  y0070: "[장중첩/폐색] 영유아",
  y0081: "[응급내시경] 성인 위장관",
  y0082: "[응급내시경] 영유아 위장관",
  y0091: "[응급내시경] 성인 기관지",
  y0092: "[응급내시경] 영유아 내시경",
  y0100: "[저체중출생아] 집중치료",
  y0111: "[산부인과응급] 분만",
  y0112: "[산부인과응급] 산과수술",
  y0113: "[산부인과응급] 부인과수술",
  y0120: "[중증화상] 전문치료",
  y0131: "[사지접합] 수족지접합",
  y0132: "[사지접합] 수족지접합 외",
  y0141: "[응급투석] HD",
  y0142: "[응급투석] CRRT",
  y0150: "[정신과적응급] 폐쇄병동입원",
  y0160: "[안과적수술] 응급",
  y0171: "[영상의학혈관중재] 성인",
  y0172: "[영상의학혈관중재] 영유아",
};
